import "@milestone-sys/web-design-system/main.css";
import "./footer.scss";
import { MILESTONE_URL } from "config";

function Footer() {
    const milestoneUrl = MILESTONE_URL();
    const aboutUsLink = milestoneUrl + "/company/about-milestone/about-us/";
    const contactUsLink = milestoneUrl + "/support/contact-us/contact-us/";
    const officesLink = milestoneUrl + "/company/about-milestone/global-offices/";
    const careersLink = milestoneUrl + "/company/career/working-in-milestone/";
    const signUpForNewsLink = "https://pardot.milestonesys.com/marketing-communication";
    const shareYourFeedbackLink = "https://pardot.milestonesys.com/l/53942/2022-01-03/l3mbx7";
    const termsOfUseLink = milestoneUrl + "/terms-of-use/";
    const privacyPolicyLink = milestoneUrl + "/privacy-policy/";
    const cookiePolicyLink = milestoneUrl + "/cookie-policy-milestone-systems/";
    const mapPolicyLink = milestoneUrl + "/minimum-advertised-price-policy/";
    const makeAWhistleblowerReportLink = milestoneUrl + "/company/about-milestone/csr/whistleblower/";
    const modernSlaveryActLink = milestoneUrl + "/company/about-milestone/csr/modern-slavery-act/";
    const currentYear = new Date().getFullYear();

    return (
        <div className="footer-column col-12" id="FooterSection">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-8 mb-6">
                        <div className="row">
                            <div className="col-12 col-xs-12">
                                <div className="footer-column__links-list footer-column__links-list--with-heading">
                                    <div className="footer-column__links-list-item">
                                        <span className="footer-column__links-list-item-link">COMPANY</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 mb-6">
                                <ul className="footer-column__links-list mt-0">
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={aboutUsLink}>About Us</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={contactUsLink}>Contact Us</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={officesLink}>Offices</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={careersLink}>Careers</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link"
                                           href={signUpForNewsLink}
                                           target="_blank"
                                           rel="noopener noreferrer">Sign up for news</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link"
                                            href={shareYourFeedbackLink}
                                            target="_blank"
                                            rel="noopener noreferrer">Share your feedback</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="col-6 mb-6">
                                <ul className="footer-column__links-list mt-0">
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={termsOfUseLink}>Terms of Use</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={privacyPolicyLink}>Privacy Policy</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={cookiePolicyLink}>Cookie Policy</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={mapPolicyLink}>MAP Policy</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={makeAWhistleblowerReportLink}>Make a whistleblower report</a>
                                    </li>
                                    <li className="footer-column__links-list-item">
                                        <a className="footer-column__links-list-item-link" href={modernSlaveryActLink}>Modern Slavery Act</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-4 mb-6">
                        <div className="footer-column__milestone-logo"></div>
                        <p className="footer-column__text">
                            For any compliance matters please contact us by sending an email to compliance@milestonesys.com
                            <br />
                            <br />
                            Copyright &#169; {currentYear} Milestone Systems A/S. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;